import { ChildAssessment } from '../store/assessment/reducer';
import store from '../store';
import { RootState } from '../store/rootReducer';

export const getCompositeChildInfo = (assessmentRunId: number) => {
    const { assessment: { compositeInfo } } = store.getState() as RootState;

    return compositeInfo?.children?.find((child: ChildAssessment) => child.childAssessmentRunId === assessmentRunId);
};

export const isGradingOnApParentAllowed = () => {
    const { assessment: { compositeInfo, gradingOnAssessmentPathParentEnabled } } = store.getState() as RootState;
    const isAllChildGraded = compositeInfo && compositeInfo.children?.length > 0
        && compositeInfo.children?.every((child: ChildAssessment) => child.isGraded);

    return gradingOnAssessmentPathParentEnabled && isAllChildGraded;
};

export const isApParentTest = () => {
    const { assessment: { isAssessmentPath, compositeInfo } } = store.getState() as RootState;

    return isAssessmentPath && compositeInfo?.children?.length > 0;
};

export const isMultipleAttemptsParentTest = () => {
    const { assessment: { isMultipleAttemptsParent } } = store.getState() as RootState;

    return isMultipleAttemptsParent;
};

export const isMultipleAttemptsChildTest = () => {
    const { assessment: { isMultipleAttemptsChild } } = store.getState() as RootState;

    return isMultipleAttemptsChild;
};


export const isParentWithNoUserQuestions = () => {
    return isMultipleAttemptsParentTest() || isApParentTest();
};
